import { userApiClient } from './userApiClient'
import { createUserAuthenticationClient } from './userAuthenticationClient'

export { createUserApiClient, userApiClient } from './userApiClient'
export { createUserAuthenticationClient, UserAuthenticationClientError } from './userAuthenticationClient'

export const userAuthenticationClient = createUserAuthenticationClient({
  apiClient: userApiClient,
})
